import React from 'react';
import {
  Button,
  FilterToolbarSearch,
  Label,
  Switch,
  filterToolbarSearchGrowClassName,
} from '@roger/ui-components';
import { Plus } from 'lucide-react';

interface GroupManagerHeaderProps {
  q: string;
  onQChange: (q: string) => void;
  showArchived: boolean;
  onShowArchivedChange: (showArchived: boolean) => void;
  onNewGroup: () => void;
}

export const GroupManagerHeader: React.FC<GroupManagerHeaderProps> = ({
  q,
  onQChange,
  showArchived,
  onShowArchivedChange,
  onNewGroup,
}) => (
  // Order matches other managers: Search → toggles → actions.
  <div className='flex flex-wrap items-end gap-3 sm:gap-4'>
    <FilterToolbarSearch
      value={q}
      onChange={onQChange}
      label='Search'
      placeholder='Search groups...'
      containerClassName={filterToolbarSearchGrowClassName}
      className='w-full'
    />
    <div className='flex items-center gap-2 self-end pb-0.5 shrink-0'>
      <Switch
        id='group-manager-show-archived'
        checked={showArchived}
        onCheckedChange={onShowArchivedChange}
      />
      <Label htmlFor='group-manager-show-archived'>Show archived</Label>
    </div>
    <Button onClick={onNewGroup} className='self-end shrink-0 ml-auto'>
      <Plus className='h-4 w-4' />
      New group
    </Button>
  </div>
);
